import { Navigate } from 'react-router-dom';
import { useKeycloak } from '../../features/auth/components/KeycloakProvider';
import { FullPageLoader } from '@shared/components/LoadingSpinner';

/**
 * Redirects authenticated users away from public-only pages (signup).
 *
 * Uses Keycloak's session as the source of truth — the SAME as ProtectedRoute — instead of
 * `authStore.isAuthenticated`, which is derived from a localStorage token via App's `initialize()`.
 * A stale token can outlive the Keycloak session (e.g. one left on the main host after a
 * cross-origin logout from a company subdomain — localStorage is per-origin). Gating on that flag
 * would send a logged-OUT user off `/signup` → `/` → ProtectedRoute → `keycloak.login()`, bouncing
 * them straight back to the sign-in page.
 */
export function PublicRoute({ children }) {
  const { keycloak, initialized } = useKeycloak();

  // Wait for Keycloak to resolve the session so we never flash-redirect on an unknown state.
  if (!initialized) {
    return <FullPageLoader />;
  }

  if (keycloak?.authenticated) {
    // Send authenticated users through the root redirect so new customers (dashboard still locked)
    // land on checkout instead of an empty dashboard.
    return <Navigate to="/" replace />;
  }

  return children;
}
